'use strict';

module.exports = [
    {
        value: 'all',
        label: 'All'
    },
    {
        value: 'planned',
        label: 'Eligible'
    },
    {
        value: 'onhold',
        label: 'Review'
    },
    {
        value: 'waitlist',
        label: 'Outreach'
    },
    {
        value: 'active',
        label: 'Active'
    },
    {
        value: 'finished',
        label: 'Discharged'
    },
    {
        value: 'cancelled',
        label: 'Ineligible'
    },
    {
        value: 'entered-in-error',
        label: 'Entered In Error'
    }
];
